var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload"},[_c('div',{staticClass:"file-upload__dropzone"},[_c('Btn',{on:{"click":_vm.selectFile}},[_vm._v("Select a File")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }